import { render, staticRenderFns } from "./ReferencePriceManage.vue?vue&type=template&id=daeb980a&"
import script from "./ReferencePriceManage.vue?vue&type=script&lang=js&"
export * from "./ReferencePriceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports